// Shared formatters for tables, KPIs, and inline cells.

// Integer rendered in Indian-numbering format (e.g. 1,23,456). Tolerates null/undefined.
export const formatInt = (v) => Math.round(v || 0).toLocaleString('en-IN');

// Coloured tone for "% sales pacing vs projection" style metrics.
//   < 50% → red, < 90% → amber, otherwise green.
export const pctTone = (pct) => {
  if (pct < 50) return 'bg-[#FEE2E2] text-[#B91C1C]';
  if (pct < 90) return 'bg-[#FEF9C3] text-[#A16207]';
  return 'bg-[#DCFCE7] text-[#15803D]';
};

// Lower-case, trim, collapse whitespace — used everywhere we compare header
// strings or do dictionary lookups case-insensitively.
export const norm = (s) => (s || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
